import { render, staticRenderFns } from "./soldProducts.vue?vue&type=template&id=b3ba566a"
import script from "./soldProducts.vue?vue&type=script&lang=js"
export * from "./soldProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports